<app-topbar></app-topbar>
<app-sidebar></app-sidebar>
<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="page-head">
        <div>
          <h3 class="page-head__title">Fund History</h3>
          <p class="page-head__sub">Track funds uploaded for IMTO partners.</p>
        </div>
        <div class="page-head__tools">
          <span class="page-pill">
            <i class="fa fa-upload"></i> {{ funds?.length || 0 }} records
          </span>
          @if (details?.permission === 'admin') {
            <span class="page-pill page-pill--balance">
              <i class="fa fa-money"></i> Current Balance
              <strong>NGN {{ $safeNavigationMigration(details?.agent?.balance) | number }}</strong>
            </span>
          }
        </div>
      </div>
    </div>

    <div class="content-body">
      <!-- Revenue, Hit Rate & Deals -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header card-toolbar">
              <h4 class="card-toolbar__title">
                <i class="fa fa-upload"></i> Funding Records
                <span class="count-pill">{{ funds?.length || 0 }}</span>
              </h4>
              <div class="card-toolbar__actions">
                <app-fund-history-filter
                  (closeFilter)="onCloseFilter($event)"
                  (filteredHistorys)="getFilteredHistorys($event)"
                  (onFormReset)="getAll()"
                ></app-fund-history-filter>

                @if (details?.permission === 'super_admin') {
                  <app-fund-history-modal
                  ></app-fund-history-modal>
                }
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive hover">
                @if (funds?.length > 0) {
                  <table class="table table-de mb-0">
                    <thead>
                      <tr>
                        <th (click)="sortOrders('created_at')" tabindex="0" (keydown.enter)="sortOrders('created_at')" (keydown.space)="sortOrders('created_at')">
                          Date
                          @if (sortType === 'created_at' && !sortReverse) {
                            <i
                              class="icons icon-sort"
                            ></i>
                          }
                          @if (sortType === 'created_at' && sortReverse) {
                            <i
                              class="icons icon-rsort"
                            ></i>
                          }
                        </th>
                        <th (click)="sortOrders('agent')" tabindex="0" (keydown.enter)="sortOrders('agent')" (keydown.space)="sortOrders('agent')">
                          IMTO Partner
                          @if (sortType === 'agent' && !sortReverse) {
                            <i
                              class="icons icon-sort"
                            ></i>
                          }
                          @if (sortType === 'agent' && sortReverse) {
                            <i
                              class="icons icon-rsort"
                            ></i>
                          }
                        </th>
                        <th (click)="sortOrders('amount_in_naira')" tabindex="0" (keydown.enter)="sortOrders('amount_in_naira')" (keydown.space)="sortOrders('amount_in_naira')">
                          Naira Equivalent
                          @if (sortType === 'amount_in_naira' && !sortReverse) {
                            <i
                              class="icons icon-sort"
                            ></i>
                          }
                          @if (sortType === 'amount_in_naira' && sortReverse) {
                            <i
                              class="icons icon-rsort"
                            ></i>
                          }
                        </th>
                        <th (click)="sortOrders('amount_in_usd')" tabindex="0" (keydown.enter)="sortOrders('amount_in_usd')" (keydown.space)="sortOrders('amount_in_usd')">
                          Foreign Currency Amount Uploaded
                          @if (sortType === 'amount_in_usd' && !sortReverse) {
                            <i
                              class="icons icon-sort"
                            ></i>
                          }
                          @if (sortType === 'amount_in_usd' && sortReverse) {
                            <i
                              class="icons icon-rsort"
                            ></i>
                          }
                        </th>
                        <th (click)="sortOrders('exchange_rate')" tabindex="0" (keydown.enter)="sortOrders('exchange_rate')" (keydown.space)="sortOrders('exchange_rate')">
                          Exchange Rate
                          @if (sortType === 'exchange_rate' && !sortReverse) {
                            <i
                              class="icons icon-sort"
                            ></i>
                          }
                          @if (sortType === 'exchange_rate' && sortReverse) {
                            <i
                              class="icons icon-rsort"
                            ></i>
                          }
                        </th>
                        <th (click)="sortOrders('current_balance')" tabindex="0" (keydown.enter)="sortOrders('current_balance')" (keydown.space)="sortOrders('current_balance')">
                          New Balance
                          <!--<i *ngIf="sortType == 'current_balance' && !sortReverse" class="icons icon-sort"></i>-->
                          <!--<i *ngIf="sortType == 'current_balance' && sortReverse" class="icons icon-rsort"></i>-->
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (fund of funds | paginate : config; track fund) {
                        <tr
                          class="pull-up"
                          [title]="fund?.status === 'reverted' ? 'Reverted' : null"
                          >
                          <td>{{ $safeNavigationMigration(fund?.created_at) | date }}</td>
                          <td>
                            <a [routerLink]="['/agent', $safeNavigationMigration(fund?.agent?.slug)]">{{
                              fund?.agent?.name
                            }}</a>
                          </td>
                          <td>NGN {{ $safeNavigationMigration(fund?.amount_in_naira) | number }}</td>
                          <td>
                            <span>{{ fund?.currency?.code }}
                            {{ $safeNavigationMigration(fund?.amount_in_usd) | number }}</span>
                            @if (fund?.status === 'reverted') {
                              <span
                                class="status-badge status-reverted"
                                >Reverted</span
                                >
                              }
                            </td>
                            <td>{{ $safeNavigationMigration(fund?.exchange_rate) | number }}</td>
                            <td>NGN {{ $safeNavigationMigration(fund?.current_balance) | number }}</td>
                            <td class="details">
                              <a
                                [routerLink]="['/fund-history', $safeNavigationMigration(fund?.id)]"
                                class="details"
                                >Details </a
                                ><i class="icons icon-leftt"></i>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    }
                    @if (funds?.length > 10) {
                      <div
                        style="text-align: center; width: 100%"
                        >
                        <pagination-controls
                          (pageChange)="pageChanged($event)"
                        ></pagination-controls>
                      </div>
                    }
                    @if (funds?.length === 0) {
                      <div
                        class="empty-state"
                        >
                        {{ emptyHistoryMessage }}
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-bottombar></app-bottombar>
